/* istanbul ignore file */

// Queries
import manifests from './ManifestsQuery.gql';
import manifest from './ManifestQuery.gql';

// Mutations
import addManifest from './AddManifestMutation.gql';
import uploadManifestDocument from './UploadManifestDocumentMutation.gql';
import updateManifest from './UpdateManifestMutation.gql';
import associateDocumentsWithManifest from './AssociateDocumentsWithManifestMutation.gql';
import deleteManifestDocuments from './DeleteManifestDocumentsMutation.gql';

export const Query = {
  manifests,
  manifest,
};

export const Mutation = {
  addManifest,
  uploadManifestDocument,
  updateManifest,
  associateDocumentsWithManifest,
  deleteManifestDocuments,
};
